<template>
  <div class="container">
    <div class="outbox">
      <div style="font-weight: 500;font-size: 18px">{{ $t("common.customer.details") }}</div>
      <ElButton size="small" type="danger" @click="handleClickDelete"
                :style="{position: 'absolute',right:lang!=='zh-CN' ?'150px':'120px',top:'55px',zIndex:9}"
                :icon="Delete"
                v-if="isSuperAdmin"
      >
        {{ $t('common.delete') }}
      </ElButton>
      <ElButton size="small" type="primary" @click="toWritePage"
                :style="{position: 'absolute',right: '26px',top:'55px',zIndex: 9}"
                :icon="Edit"
      >{{ $t('common_personal_register') }}
      </ElButton>
    </div>
    <div class="content">
      <div id="inner_box">
        <el-tabs
            v-model="activeName"
            class="demo-tabs"
            :key="activeName"
            @tab-click="handleClick"
        >
          <div class="inner">
            <el-tab-pane lazy :label="$t('common.customer.archives')" name="1">
              <template v-if="types === '1'">
                <el-scrollbar height="calc(100vh - 154px)">
                  <div class="box_content">
                    <div class="inners">
                      <Forms :isCreate="false">
                        <template #createMessage>
                          <div style="display: flex;align-items: center">
                            <div class="gutter_my">
                              <el-form-item
                                  :label="$t('common.region.name')"
                                  prop="zoneAddress"
                              >
                                <el-select
                                    size="small"
                                    v-model="ruleForm.zoneAddress"
                                    :placeholder="$t('common.please.select')"
                                    disabled
                                >
                                </el-select>
                              </el-form-item>
                            </div>
                            <div class="gutter_my">
                              <el-form-item class="sp_edit_btn">
                                <template #label>
                                  <div style="display: flex;justify-content: space-between;width: 100%;">
                                    <div>{{ $t('common.customer.number') }}</div>
                                    <el-button v-if="disabledFlag" type="primary" link @click="handleEdit">
                                      {{
                                        $t('common.edit')
                                      }}
                                    </el-button>
                                    <el-button v-else type="primary" link @click="handleEdit">
                                      {{
                                        $t('common.cancel')
                                      }}
                                    </el-button>
                                  </div>
                                </template>
                                <el-input
                                    size="small"
                                    :disabled="disabledFlag"
                                    v-model="ruleForm.customerCode"
                                    :placeholder="$t('common.please.input')"
                                />
                              </el-form-item>
                            </div>
                            <div class="gutter_my">
                              <el-form-item
                                  :label="$t('common_customer_name')"
                                  prop="customerName"
                              >
                                <el-input
                                    size="small"
                                    v-model="ruleForm.customerName"
                                    :placeholder="$t('common.please.input')"
                                />
                              </el-form-item>
                            </div>
                            <div class="gutter_my">
                              <el-form-item
                                  :label="$t('common.customer.source')"
                                  prop="customerOrigin"
                              >
                                <SelectEditTag v-model:selectedMember="ruleForm.customerOriginList" ref="selectTag"
                                               :typeSelect="1" :isOnlyTagFlag="true"></SelectEditTag>
                              </el-form-item>
                            </div>
                            <div class="gutter_my">
                              <el-form-item :label="$t('sending.customer.search.targetTime')">
                                <el-input
                                    size="small"
                                    v-model="ruleForm.createTime"
                                    :placeholder="$t('common.please.input')"
                                    disabled
                                />
                              </el-form-item>
                            </div>
                          </div>
                          <div style="display: flex;align-items: center">
                            <div class="gutter_my">
                              <el-form-item :label="$t('common_byinput')">
                                <el-input
                                    size="small"
                                    v-model="ruleForm.createName"
                                    :placeholder="$t('common.please.input')"
                                    disabled
                                />
                              </el-form-item>
                            </div>
                            <div class="gutter_my">
                              <el-form-item :label="$t('common.bybranch')">
                                <el-input
                                    size="small"
                                    v-model="ruleForm.mangerVOList[0].managerName"
                                    :placeholder="$t('common.please.input')"
                                    disabled
                                />
                              </el-form-item>
                            </div>
                            <div class="gutter_my" style="position: relative;z-index: -9999">
                              <el-form-item :label="$t('common.bybranch')">
                                <el-input
                                    size="small"
                                    v-model="ruleForm.mangerVOList[0].managerName"
                                    :placeholder="$t('common.please.input')"
                                    disabled
                                />
                              </el-form-item>
                            </div>
                            <div class="gutter_my" style="position: relative;z-index: -9999">
                              <el-form-item :label="$t('common.bybranch')">
                                <el-input
                                    size="small"
                                    v-model="ruleForm.mangerVOList[0].managerName"
                                    :placeholder="$t('common.please.input')"
                                    disabled
                                />
                              </el-form-item>
                            </div>
                            <div class="gutter_my" style="position: relative;z-index: -9999">
                              <el-form-item :label="$t('common.bybranch')">
                                <el-input
                                    size="small"
                                    v-model="ruleForm.mangerVOList[0].managerName"
                                    :placeholder="$t('common.please.input')"
                                    disabled
                                />
                              </el-form-item>
                            </div>
                          </div>
                        </template>
                      </Forms>
                      <div class="link_user_box">
                        <Cards
                            :title="$t('common.contact.list')"
                            :isShowTitle="true"
                        >
                          <el-row :gutter="24">
                            <el-col :span="6">
                              <el-button
                                  size="small"
                                  type="primary"
                                  @click="handleClickAdd"
                              >{{ $t("common.contact.add") }}
                              </el-button>
                            </el-col>
                          </el-row>
                          <ContactTable
                              @clickEdit="onClickEdit"
                              @clickHistory="clickHistoryChange"
                          ></ContactTable>
                        </Cards>
                      </div>
                      <!-- dialog -->
                      <!-- 添加联系人-->
                      <el-dialog
                          v-model="dialogVisible"
                          width="860"
                          style="min-width: 600px;"
                          :append-to-body="true"
                          @close="cancelClick"
                          top="10em"
                          :close-on-click-modal="false"
                          v-loading="isLoadingDetail"
                          :title="isEdit?$t('common.email.updateContacts'):$t('common.contact.add')"
                      >
                        <!--                        <div class="tops">-->
                        <!--                          <div class="span_block"></div>-->
                        <!--                          <div class="inner_text">{{ $t("contact.info") }}</div>-->
                        <!--                        </div>-->
                        <el-form
                            ref="ruleFormRef"
                            :model="ruleFormUsers"
                            label-width="50px"
                            class="demo-ruleForm-ssssss"
                        >
                          <el-checkbox
                              style="margin-left: 12px;font-size: 13px !important;"
                              :label="$t('common.mainContact')"
                              v-model="ruleFormUsers.isMain"
                          />
                          <div style="max-height: 1000px;height:max-content;overflow:hidden scroll;margin-top:12px;">
                            <div style="display: flex;width:100%;align-items: center">
                              <div class="contact_my">
                                <el-form-item
                                    :label="$t('common.name')"
                                    prop="name"
                                    :rules="[{required: true, message: $t('form.contact.name.reg'), trigger: ['blur']}]"
                                >
                                  <el-input
                                      size="small"
                                      v-model="ruleFormUsers.name"
                                      :placeholder="$t('90201')"
                                  />
                                </el-form-item>
                              </div>
                              <div class="contact_my">
                                <el-form-item
                                    :label="$t('common.user.nick1')"
                                    prop="name"
                                >
                                  <el-input
                                      size="small"
                                      v-model="ruleFormUsers.nickName"
                                      :placeholder="$t('common.please.input')"
                                  />
                                </el-form-item>
                              </div>
                              <div class="contact_my">
                                <el-form-item :label="$t('common.sex')" prop="sex">
                                  <!--                                <el-radio-group-->
                                  <!--                                    size="small"-->
                                  <!--                                    v-model="ruleFormUsers.sex"-->
                                  <!--                                    class="ml-4"-->
                                  <!--                                >-->
                                  <!--                                  <el-radio :label="1" :value="1">{{-->
                                  <!--                                      $t("common.man")-->
                                  <!--                                    }}-->
                                  <!--                                  </el-radio>-->
                                  <!--                                  <el-radio :label="2" :value="2">{{-->
                                  <!--                                      $t("common.woman")-->
                                  <!--                                    }}-->
                                  <!--                                  </el-radio>-->
                                  <!--                                </el-radio-group>-->
                                  <el-select
                                      v-model="ruleFormUsers.sex"
                                      size="small"
                                      class="ml-4"
                                      :placeholder="$t('common.please.select')"
                                      style="width: 120px"
                                  >
                                    <el-option :label="$t('common.man')" :value="1"/>
                                    <el-option :label="$t('common.woman')" :value="2"/>
                                  </el-select>
                                </el-form-item>
                              </div>
                              <div class="contact_my">
                                <el-form-item
                                    :label="$t('common.dateofbirth')"
                                    prop="birthday"
                                >
                                  <el-date-picker
                                      size="small"
                                      v-model="ruleFormUsers.birthday"
                                      type="date"
                                      :placeholder="$t('common.please.select')"
                                  />
                                </el-form-item>
                              </div>
                              <!--                              <div class="contact_my">-->
                              <!--                                <el-form-item-->
                              <!--                                    style="display: none"-->
                              <!--                                    :label="$t('common.company.position')"-->
                              <!--                                    prop="post"-->
                              <!--                                >-->
                              <!--                                  <el-input-->
                              <!--                                      size="small"-->
                              <!--                                      :placeholder="$t('sys.tip.input.position')"-->
                              <!--                                  />-->
                              <!--                                </el-form-item>-->
                              <!--                              </div>-->
                            </div>
                            <div style="display: flex;width:100%;align-items: center;">
                              <div class="contact_my">
                                <el-form-item
                                    :label="$t('common.department')"
                                    prop="phone"
                                >
                                  <el-input
                                      size="small"
                                      v-model="ruleFormUsers.departName"
                                      :placeholder="$t('common.please.input')"
                                  />
                                </el-form-item>
                              </div>
                              <div class="contact_my">
                                <el-form-item
                                    :label="$t('common.company.position')"
                                    prop="post"
                                >
                                  <el-input
                                      size="small"
                                      v-model="ruleFormUsers.post"
                                      :placeholder="$t('sys.tip.input.position')"
                                  />
                                </el-form-item>
                              </div>
                              <!--                              <div class="contact_my">-->
                              <!--                                <el-form-item-->
                              <!--                                    :label="$t('common.contact.phone')"-->
                              <!--                                    prop="telPhone"-->
                              <!--                                >-->
                              <!--                                  <el-input-->
                              <!--                                      size="small"-->
                              <!--                                      v-model="ruleFormUsers.telPhone"-->
                              <!--                                      :placeholder="$t('sys.tip.input.contact.phone')"-->
                              <!--                                  />-->
                              <!--                                </el-form-item>-->
                              <!--                              </div>-->
                              <div class="contact_my">
                                <el-form-item
                                    :label="$t('common.remark')"
                                    prop="remark"
                                >
                                  <el-input
                                      size="small"
                                      v-model="ruleFormUsers.remark"
                                      :placeholder="$t('sys.tip.input.remark')"
                                      @click="remarkDesSalVisible = true"
                                  />
                                  <el-dialog v-model="remarkDesSalVisible" :title="$t('common.remark')">
                                    <template #default>
                                      <el-input
                                          style="white-space: pre-wrap;word-break: break-all"
                                          v-model="ruleFormUsers.remark"
                                          type="textarea"
                                          :rows="5"
                                          size="small"
                                          :placeholder="$t('common.please.input')"
                                      />
                                    </template>
                                    <template #footer style="border-top: 1px solid">
                                      <div class="dialog-footer">
                                        <el-button size="small" @click="remarkDesSalVisible = false"
                                                   style="margin-right: 20px"
                                        >{{ $t('common.sss16') }}
                                        </el-button
                                        >
                                        <el-button
                                            size="small"
                                            type="primary"
                                            @click="remarkDesSalVisible = false"
                                        >{{ $t('common.save') }}
                                        </el-button
                                        >
                                      </div>
                                    </template>
                                  </el-dialog>
                                </el-form-item>
                              </div>
                            </div>
                            <el-row :gutter="24" style="margin-top: -12px">
                              <el-col :span="12" style="padding-right: 10px !important;">
                                <MyTitles :title="$t('common.emailbox')">
                                  <template #content>
                                    <div class="bottoms asterisk-left">
                                      <el-form-item
                                          :label="index===0?$t('common.emailbox'):' '"
                                          class="sp_form_item vertical-form-item"
                                          style="margin-top: 20px;padding-bottom: 0px"
                                          v-for="(
                                          item, index
                                        ) in ruleFormUsers.mailContactEmailList"
                                          :style="{marginTop:index===0? '18px !important':'8px !important'}"
                                          :key="index"
                                          :prop="
                                            'mailContactEmailList[' +
                                            index +
                                            '].content'
                                          "
                                          :rules="[
                                          {
                                            pattern:
                                            emailReg,
                                            message:$t('form.email.reg') ,
                                            trigger: ['change','blur'],
                                          },
                                        ]"
                                      >
                                        <div class="email-input">
                                          <el-input
                                              size="small"
                                              v-model="item.content"
                                              :placeholder="$t('90201')"
                                              @input="handleCheckForm(3,item)"
                                          />
                                          <el-button
                                              link
                                              class="danger_delete_btn_link"
                                              size="small"
                                              type="danger"
                                              style="
                                                                       margin: 0px 5px !important;
                                                                        cursor: pointer;
                                                                      "
                                              @click="removeEmail(index,item)"
                                          >
                                            {{ $t('common.delete') }}
                                          </el-button>
                                        </div>
                                        <el-button
                                            v-if="index===ruleFormUsers.mailContactEmailList.length-1"
                                            size="small"
                                            link
                                            style="margin-top: 20px;"
                                            @click="addEmail"
                                            type="primary"
                                        >
                                          <template #icon>
                                            <el-icon>
                                              <Plus/>
                                            </el-icon>
                                          </template>
                                          {{ $t('common.add') }}
                                        </el-button>
                                        <div v-else style="width: 93px !important;"></div>
                                      </el-form-item>
                                      <!--                                      <el-form-item-->
                                      <!--                                          style="margin: 0px !important;justify-content: start !important;margin-top: 15px !important;">-->
                                      <!--                                        <el-button-->
                                      <!--                                            v-if="!ruleFormUsers.mailContactEmailList.length>0"-->
                                      <!--                                            size="small"-->
                                      <!--                                            @click="addEmail"-->
                                      <!--                                            :icon="Plus"-->
                                      <!--                                            type="primary"-->
                                      <!--                                        >-->
                                      <!--                                          {{ $t("common.add") }}-->
                                      <!--                                        </el-button>-->
                                      <!--                                      </el-form-item>-->
                                    </div>
                                  </template>
                                </MyTitles>
                              </el-col>
                              <el-col :span="12" style="padding-right: 10px !important;">
                                <MyTitles :title="$t('common.contact.phone')">
                                  <template #content>
                                    <div class="bottoms asterisk-left">
                                      <el-form-item
                                          :label-width="39"
                                          :label="index===0?$t('common.contact.phone'):' '"
                                          class="sp_form_item vertical-form-item"
                                          style="margin-top: 20px;padding-bottom: 0px;"
                                          v-for="(item, index) in ruleFormUsers.contactPhoneList"
                                          :style="{marginTop:index===0?'18px !important':'8px !important'}"
                                          :key="index"
                                          :prop="'contactPhoneList['+index +'].content'"
                                      >
                                        <div class="email-input">
                                          <el-input
                                              size="small"
                                              v-model="item.content"
                                              :placeholder="$t('common.please.input')"
                                          />
                                          <el-button
                                              link
                                              class="danger_delete_btn_link"
                                              size="small"
                                              type="danger"
                                              style="
                                              margin: 0px 5px !important;
                                              cursor: pointer;
                                              "
                                              @click="removePhone(index,item)"
                                          >
                                            {{ $t('common.delete') }}
                                          </el-button>
                                        </div>
                                        <el-button
                                            style="margin-top: 20px;"
                                            v-if="index===ruleFormUsers.contactPhoneList.length-1"
                                            size="small"
                                            @click="addPhone"
                                            type="primary"
                                            link
                                        >
                                          <template #icon>
                                            <el-icon>
                                              <Plus/>
                                            </el-icon>
                                          </template>
                                          {{ $t('common.add') }}
                                        </el-button>
                                        <div v-else style="width: 93px !important;"></div>
                                      </el-form-item>
                                    </div>
                                  </template>
                                </MyTitles>
                              </el-col>
                            </el-row>
                            <el-row :gutter="24" style="margin-top: 20px">
                              <el-col :span="12" style="padding-right: 10px !important;">
                                <MyTitles :title="$t('common.she.mei')">
                                  <template #content>
                                    <div class="bottoms asterisk-left">
                                      <el-form-item
                                          :label="index===0?$t('common.she.mei'):' '"
                                          class="sp_form_item vertical-form-item"
                                          style="margin-top: 20px;padding-bottom: 0px"
                                          v-for="(item, index) in ruleFormUsers.contactWayList"
                                          :style="{marginTop:index===0? '18px !important':'8px !important'}"
                                          :key="index"
                                          :prop="'contactWayList[' +index +'].content'"
                                      >
                                        <div class="email-input">
                                          <el-input
                                              size="small"
                                              v-model="item.content"
                                              :placeholder="$t('common.please.input')"
                                          />
                                          <el-button
                                              link
                                              class="danger_delete_btn_link"
                                              size="small"
                                              type="danger"
                                              style="margin: 0px 5px !important;cursor: pointer;"
                                              @click="removeText(index,item)"
                                          >
                                            {{ $t('common.delete') }}
                                          </el-button>
                                        </div>
                                        <el-button
                                            v-if="index===ruleFormUsers.contactWayList.length-1"
                                            size="small"
                                            @click="addText"
                                            type="primary"
                                            style="margin-top: 20px;"
                                            link
                                        >
                                          <template #icon>
                                            <el-icon>
                                              <Plus/>
                                            </el-icon>
                                          </template>
                                          {{ $t('common.add') }}
                                        </el-button>
                                        <div v-else style="width: 93px !important;"></div>
                                      </el-form-item>
                                    </div>
                                  </template>
                                </MyTitles>
                              </el-col>
                              <el-col :span="12" style="padding-left: 10px !important;padding-right: 10px !important;">
                                <MyTitles :title="$t('common.memorialday')">
                                  <template #content>
                                    <div class="remembers asterisk-left">
                                      <!-- <RememberDate></RememberDate> -->
                                      <div style="width: 100% !important;">
                                        <div
                                            v-for="(event, index) in ruleFormUsers.mailContactSouvenirList"
                                            :key="index"
                                            style="display: flex;flex-direction: column"
                                        >
                                          <div style="width: 100%;" class="event-input">
                                            <span
                                                style="width: 40px;font-size: 13px;color: rgba(0, 0, 0, 0.85);padding-left: 2px">
                                              {{
                                                index === 0 ? $t('common.memorialday') : ''
                                              }}
                                            </span>
                                            <el-input
                                                size="small"
                                                v-model="event.remark"
                                                :placeholder="$t('common.contact.info.anniversary.name')"
                                                ref="inputRef"
                                                style="width: 50% !important;"
                                            ></el-input>
                                            <div style="margin: 0 10px"></div>
                                            <el-date-picker
                                                size="small"
                                                v-model="event.souvenirDay"
                                                type="date"
                                                class="event-text"
                                                :placeholder="$t('common.please.select')"
                                                style="width: 40% !important;"
                                            />
                                            <div class="setting">
                                              <el-button
                                                  size="small"
                                                  v-if="event.showButtons"
                                                  @click="removeEvent(index)"
                                                  link
                                                  style="margin: 0px 5px !important;"
                                                  type="danger"
                                              >{{ $t("common.delete") }}
                                              </el-button>
                                              <el-button
                                                  size="small"
                                                  v-if="!event.showButtons"
                                                  @click="removeEvent(index)"
                                                  link
                                                  style="margin: 0px 5px !important;"
                                                  type="danger"
                                              >{{ $t("common.delete") }}
                                              </el-button>
                                            </div>
                                          </div>
                                          <div style="margin-top: 10px;margin-left: 38px;">
                                            <el-button v-if="index===ruleFormUsers.mailContactSouvenirList.length-1"
                                                       size="small"
                                                       @click="addEvent" type="primary"
                                                       link
                                            >
                                              <template #icon>
                                                <el-icon>
                                                  <Plus/>
                                                </el-icon>
                                              </template>
                                              {{ $t('common.add') }}
                                            </el-button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </template>
                                </MyTitles>
                              </el-col>
                            </el-row>
                          </div>
                        </el-form>
                        <template #footer>
                        <span class="dialog-footer" style="padding-top: 0px !important;">
                          <el-button
                              size="small"
                              style="margin: 0px 6px"
                              @click="cancelClick"
                          >{{ $t("common.cancel") }}</el-button
                          >
                          <el-button
                              size="small"
                              style="margin: 0px 6px"
                              type="primary"
                              :loading="loadings"
                              @click="addCustomerContact"
                          >
                            {{ $t("common.save") }}
                          </el-button>
                        </span>
                        </template>
                      </el-dialog>
                    </div>
                  </div>
                </el-scrollbar>
              </template>
              <!--              <template v-else-if="types === '2'">-->
              <template v-else>
                <div class="box_content">
                  <div>
                    <div class="inners">
                      <div>
                        <div class="titles">
                          <h3>{{ $t("common.cds25") }}</h3>
                        </div>
                        <div class="small_box">
                          <TableShows :table-data="companyInfo"/>
                        </div>
                      </div>
                      <div style="margin-top: 40px">
                        <div class="titles">
                          <h3>{{ $t("common.marketing.information") }}</h3>
                        </div>
                        <div class="small_box">
                          <TableShows :table-data="marketingInfo"/>
                        </div>
                      </div>
                      <div style="margin-top: 40px">
                        <div class="titles">
                          <h3>{{ $t("common.contact") }}</h3>
                        </div>
                        <div
                            class="small_box"
                            v-for="(item, index) in contactInfo"
                            :key="index"
                        >
                          <TableShows :table-data="item"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </el-tab-pane>
            <el-tab-pane lazy :label="$t('email.history')" name="2" class="linkUser">
              <div class="views">
                <CallLog
                    ref="callLog"
                    :key="mainKey"
                    @change="changeTarget"
                    @handleChangeRow="handleChange"
                    :targetCheckoutItem="{ targetCheckoutItem, islink }"
                ></CallLog>
              </div>
            </el-tab-pane>
            <el-tab-pane lazy :label="$t('follow.history')" name="3">
              <FollowLog></FollowLog>
            </el-tab-pane>
            <el-tab-pane lazy :label="$t('common.operation.log')" name="4">
              <div class="box_content">
                <div class="link_user_box">
                  <Cards :isShowTitle="false">
                    <el-table
                        ref="multipleTableRef"
                        :data="tableDataLogs"
                        style="width: 100%; margin-top: 10px"
                        :v-loading="isLoadingLog"
                        :header-cell-style="{
                        'text-align': 'left',
                        background: '#f9f9f9',
                        color: 'black',
                        padding: '8px 0px',
                      }"
                    >
                      <el-table-column
                          v-for="item in table_columns_logs"
                          :key="item.key"
                          :label="item.key"
                          :prop="item.value"
                          :width="item.value==='remark'?auto:200"
                      >
                        <template #default="{row}">
                          <template v-if="item.value === 'remark' || item.value === 'userName'">
                            <el-tooltip
                                class="custom-tooltip"
                                effect="dark"
                                :content="row[item.value]"
                                placement="top"
                                :show-after="1200"
                            >
                              <span class="popover-content"
                                    style="width: 100%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis">
                                {{ row[item.value] }}
                              </span>
                            </el-tooltip>
                          </template>
                          <template v-else>
                            <span class="popover-content">{{ row[item.value] }}</span>
                          </template>
                        </template>
                      </el-table-column>
                      <template #empty>
                        <el-empty
                            :description="$t('common.data.empty')"
                            :image="emptyUrl"
                        />
                      </template>
                    </el-table>
                    <!-- 分页 -->
                    <div class="pages">
                      <el-pagination
                          v-model:current-page="currentLog"
                          v-model:page-size="sizeLog"
                          background
                          size="small"
                          layout="total, prev, pager, next"
                          v-if="totalsLog"
                          :total="totalsLog"
                          @current-change="handleCurrentChange"
                      />
                    </div>
                  </Cards>
                </div>
              </div>
            </el-tab-pane>
          </div>
        </el-tabs>
      </div>
    </div>
  </div>


  <DeleteCustomer v-if="dialogVisiblePopover" v-model="dialogVisiblePopover" @close="closeDialog"
                  :multipleSelection="multipleSelection" :isDetail="true"
  ></DeleteCustomer>
</template>

<script setup>
import {ref, computed, reactive, onMounted, nextTick, watch} from "vue";
import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import dayjs from "dayjs";
import {ElMessage, ElTable} from "element-plus";
import TableShows from "./Tables/TableShows.vue";
import Cards from "./Cards.vue";
import Forms from "./CreateCheck/Forms.vue";
import MyTitles from "./Detail/MyTitles.vue";
import ContactTable from "./Detail/ContactTable.vue";
import CallLog from "@/views/components/CallLog.vue";
import {debouncePlus, isEmpty, throttle} from "@/utils/mylodash"

import {
  addMailCustomerContact, checkEmailAndWebsite, checkMainContact,
  editMailCustomerContact,
  getUserLogList, updateMailCustomerAudit,
} from "@/api/customer";
import {Delete, Edit, Plus, Position} from "@element-plus/icons-vue";
import {emailReg, emptyUrl, TIME_OUT} from "@/utils/statusParams";
import {i18n} from "@/lang";
import FollowLog from "@/views/Customer/Detail/FollowLog.vue";
import DeleteCustomer from "@/components/DiaPops/DeleteCustomer.vue";
import SelectEditTag from "@/components/SelectEditTag.vue";
import sessionStore from "@/utils/sessionStore";

const empty = ref(i18n.global.t('select.empty'))
const lang = computed(() => store.state.system.langLocal)
const customerLevels = computed(() => store.state.customer.customerLevels)
const router = useRouter();
const route = useRoute()
const store = useStore();
const ruleForm = computed(() => store.state.customer.ruleForm);

watch(() => ruleForm.value, (newValue) => {
  if (newValue) {
    disabledFlag.value = true
  }
})


// 客户id
const customerId = ref("");
const remarkDesSalVisible = ref(false)

const addEmail = () => addContactItem('mailContactEmailList', 'content');
const addPhone = () => addContactItem('contactPhoneList', 'content');
const addText = () => addContactItem('contactWayList', 'content')

const addContactItem = (listKey, fieldKey = 'email') => {
  const list = ruleFormUsers[listKey];

  // 1️⃣ 判断是否已有空字段
  // const hasEmpty = list.some((item) => item[fieldKey] === '');
  // if (hasEmpty) {
  //   ElMessage.error(i18n.global.t('detail.add.customer'));
  //   return;
  // }

  // 2️⃣ 添加一个新项
  list.push({
    [fieldKey]: '',
    isDefault: 0,
  });

  // 3️⃣ 确保第一个为默认项
  if (list.length > 0) {
    list[0].isDefault = 1;
  }
};


const customerSelectData = computed(() => store.state.cusList.customerSelectData);
const removeContactEmail = ref([]);
const removeContactPhone = ref([]);
const removeContactText = ref([])
const removeEmail = (index, item) => {
  if (ruleFormUsers.mailContactEmailList.length === 1) {
    return
  }
  removeContactItem("mailContactEmailList", removeContactEmail, index, item);
};

const removePhone = (index, item) => {
  if (ruleFormUsers.contactPhoneList.length === 1) {
    return
  }
  removeContactItem("contactPhoneList", removeContactPhone, index, item);
};

const removeText = (index, item) => {
  if (ruleFormUsers.contactWayList.length === 1) {
    return
  }
  removeContactItem("contactWayList", removeContactText, index, item);
}

const removeContactItem = (listKey, removeListRef, index, item) => {
  // 1️⃣ 记录被删除的对象（仅保留有 id 的）
  removeListRef.value = [...removeListRef.value, item].filter((x) => x.id);

  // 2️⃣ 删除当前项
  ruleFormUsers[listKey].splice(index, 1);

  // 3️⃣ 深拷贝以防止响应式干扰
  const copObj = JSON.parse(JSON.stringify(ruleFormUsers));
  const contactList = copObj[listKey];

  // 4️⃣ 判断是否有默认项
  const hasDefault = contactList.some((x) => x.isDefault === 1);

  // 5️⃣ 重新赋值处理逻辑
  ruleFormUsers[listKey] = hasDefault
      ? contactList.filter((x) => x.email !== "" && x.phone !== "")
      : contactList
          .map((x, idx) => {
            if (idx === 0) {
              return x.id ? x : {...x, isDefault: 1};
            }
            return x;
          })
          .filter((x) => x.email !== "" && x.phone !== "");
};

const exitMainContactFlag = ref(false)
const handleClickAdd = async () => {
//   添加联系人
  dialogVisible.value = true
  try {
    const payload = {
      customerId: route.params.userId,
      teamId: teamId.value
    }
    const res = await checkMainContact(payload)
    console.log(res, 'asdfasfasfdsaf')
    exitMainContactFlag.value = res.result?.exitMainContact
    if (exitMainContactFlag.value) {
      ruleFormUsers.isMain = false
    } else {
      ruleFormUsers.isMain = true;
    }
  } catch (e) {
    ruleFormUsers.isMain = false
    console.log(e)
  }
}

// 表单数据
const ruleFormUsers = reactive({
  departName: "",
  name: "",
  sex: 1,
  post: "",
  telPhone: "",
  birthday: null,
  remark: "",
  nickName: "",
  isMain: false,
  contactWayList: [
    {
      content: "",
      isDefault: 1,
    }
  ],
  contactPhoneList: [
    {
      content: "",
      isDefault: 1,
    }
  ],
  mailContactEmailList: [
    {
      content: "",
      isDefault: 1,
    },
  ],
  mailContactSouvenirList: [
    {
      remark: "",
      souvenirDay: "",
      editing: true,
      showButtons: true,
    }
  ],
});

const mainKey = ref(1);
const contactList = computed(() => store.state.customer.contactList);
// 权限控制
const isSuperAdmin = computed(() => store.getters["user/isSuperAdmin"])
const isAdmin = computed(() => store.getters["user/isAdmin"])
// 公司信息
const companyInfo = ref([]);
// 营销信息
const marketingInfo = ref([]);
// 联系人信息
const contactInfo = ref([]);
// 页面加载直接进行展示
const showActiveItem = async () => {
  if (ruleForm.value) {
    // console.log(customerId, "sdf");
    await store.dispatch("customer/getQueryById", {
      customerId: customerId.value,
    });
    const {
      phoneWayList,
      setUpTime,
      economicNature,
      companyWebsite,
      companyAddress,
      companyFax,
      emailWayList,
      companyRemark,
      // ----
      customerType,
      customerLevel,
      marketingRemark,
      zoneAddress,
    } = ruleForm.value;
    console.log(ruleForm.value, "ffffff");
    // 公司信息
    companyInfo.value = [
      {
        name: i18n.global.t("common.region.name"),
        value: zoneAddress,
      },
      {
        name: i18n.global.t("common.customer.source"),
        value: item?.mailCustomerOriginDetailVoList?.filter(item => item.name !== '').length > 0 ? item?.mailCustomerOriginDetailVoList?.filter(item => item.name !== '') : '',
      },
      {
        name: i18n.global.t('common.establishment'), value: setUpTime
      },
      {
        name: i18n.global.t('common.economicnature'), value: economicNature
      },
      {
        name: i18n.global.t('common.cds6'),
        value:
            emailWayList.length !== 0 ? emailWayList.filter((item) => item.isDefault === 1)[0]?.content :
                [],
      },
      {
        name: i18n.global.t('common.cds2'), value: companyAddress
      },
      {
        name: i18n.global.t("more.check.phone"),
        value: phoneWayList.length !== 0 ? phoneWayList.filter((item) => item.isDefault === 1)[0]?.content :
            [],
      },
      {
        name: i18n.global.t('common.faxnumber'), value:
        companyFax
      },
      {
        name: i18n.global.t('common.company.website'), value:
        companyWebsite
      },
      {
        name: i18n.global.t('other.remark'), value:
        companyRemark
      },
    ];
    // 营销信息
    marketingInfo.value = [
      {name: i18n.global.t('common.customer.type'), value: customerType},
      {name: i18n.global.t('common_customer_level'), value: customerLevel},
      {
        name: i18n.global.t('common.interest.product'),
        value: item?.mailProductDetailVoList?.filter(item => item.name !== '').length > 0 ? item?.mailProductDetailVoList?.filter(item => item.name !== '') : ''
      },
      {name: i18n.global.t('create.customer.des'), value: marketingRemark},
    ];
    // 联系人详情
    await store.commit("customer/setContactPage", {
      page: 1,
      pageSize: 999,
    });
    await store.dispatch("customer/getContactList");
    // 清除数据干扰
    contactInfo.value = [];
    // 联系人详情
    contactInfo.value = contactList.value.map((item) => [
      {name: i18n.global.t("common.name"), value: item.name},
      {name: i18n.global.t("common.edm"), value: item.email},
    ]);
  }
};

// 添加联系人表单
const loadings = ref(false)
const ruleFormRef = ref(null);
const addCustomerContact = throttle(() => {
  ruleFormRef.value.validate(async (valid, fields) => {
    if (valid) {
      const copObj = JSON.parse(JSON.stringify(ruleFormUsers));
      const {mailContactSouvenirList, mailContactEmailList, contactPhoneList, contactWayList} = copObj;
      let resMails = mailContactSouvenirList.map((item) => {
        return {
          ...item,
          souvenirDay: item.souvenirDay && dayjs(item.souvenirDay).isValid()
              ? dayjs(item.souvenirDay).format("YYYY-MM-DD")
              : null,
        };
      });

      //默认邮箱
      const selectDefault = mailContactEmailList.some(
          (item) => item.isDefault === 1
      )
          ? mailContactEmailList.filter(_ => _.content !== "")
          : mailContactEmailList.map((item, index) => {
            if (index === 0) {
              if (item.id) {
                return {...item, isDefault: 1}
              } else {
                return {isDefault: 1, content: item.content};
              }
            } else {
              return item;
            }
          }).filter(_ => _.content !== "");
      // 默认处理电话
      const hasDefaultPhone = contactPhoneList.some(item => item.isDefault === 1)
      const selectDefaultPhone = hasDefaultPhone
          ? contactPhoneList.filter(_ => _.content !== "")
          : contactPhoneList
              .map((item, index) => ({
                ...item,
                isDefault: index === 0 ? 1 : 0,
              }))
              .filter(_ => _.content !== "")

      // 默认处理新媒体
      const hasDefaultWay = contactWayList.some(item => item.isDefault === 1)
      const selectDefaultWay = hasDefaultWay
          ? contactWayList.filter(_ => _.content !== "")
          : contactWayList
              .map((item, index) => ({
                ...item,
                isDefault: index === 0 ? 1 : 0,
              }))
              .filter(_ => _.content !== "")
      delete copObj.birthday;
      // delete copObj.mailContactSouvenirList;
      // delete copObj.mailContactEmailList;
      const targetObj = {
        ...copObj,
        birthday:
            (ruleFormUsers.birthday && dayjs(ruleFormUsers.birthday).isValid())
                ? dayjs(ruleFormUsers.birthday).format("YYYY-MM-DD")
                : null,
        mailContactSouvenirList: resMails,
        mailContactEmailList: selectDefault,
        contactPhoneList: selectDefaultPhone,
        contactWayList: selectDefaultWay,
        customerId: customerId.value,
        teamId: teamId.value,
        isMain: ruleFormUsers.isMain ? 1 : 0
      };
      if (!isEdit.value) {
        // console.log(targetObj, "添加");
        // 添加联系人邮箱
        loadings.value = true
        try {
          console.log(targetObj, 'targetObj')
          let res = await addMailCustomerContact(targetObj);
          loadings.value = false;
          ElMessage.success(res.message);
          dialogVisible.value = false;
          store.dispatch("customer/getContactList");
          isEdit.value = false;
          // 重置表单
          ruleFormRef.value.resetFields();
          formReset()
        } catch (e) {
          loadings.value = false;
        }
      } else {
        // console.log(targetObj, "编辑");
        try {
          loadings.value = true
          let targetDefaultIdArray = null;
          let theLastTarget = [];
          let theLastTargetPhone = [];
          let theLastTargetWay = [];
          try {
            if (ruleFormUsers.mailContactEmailList.filter(item => item.id && item.content === "").length > 0) {
              targetDefaultIdArray = ruleFormUsers.mailContactEmailList.filter(item => item.id && item.content === "").map((_) => _.id)
              theLastTarget = sessionStore.get("ContactMessage").mailContactEmailList.filter(item => (targetDefaultIdArray.includes(item.id)));
              console.log(targetDefaultIdArray, theLastTarget, contactMessageTemp.value, 'targetDefaultIdArray')
            }
            if (ruleFormUsers.contactPhoneList.filter(item => item.id && item.content === "").length > 0) {
              targetDefaultIdArray = ruleFormUsers.contactPhoneList.filter(item => item.id && item.content === "").map((_) => _.id)
              theLastTargetPhone = sessionStore.get("ContactMessage")?.mailContactPhoneList.filter(item => (targetDefaultIdArray.includes(item.id)));
            }
            if (ruleFormUsers.contactWayList.filter(item => item.id && item.content === "").length > 0) {
              targetDefaultIdArray = ruleFormUsers.contactWayList.filter(item => item.id && item.content === "").map((_) => _.id)
              theLastTargetWay = sessionStore.get("ContactMessage")?.mailContactWayList.filter(item => (targetDefaultIdArray.includes(item.id)));
            }
          } catch (e) {
            console.log(e)
          }
          let res = await editMailCustomerContact({
            ...targetObj,
            id: contactId.value,
            mailContactDeleteEmailList: [...removeContactEmail.value, ...theLastTarget],
            deleteContactPhoneList: [...removeContactPhone.value, ...theLastTargetPhone],
            deleteContactWayList: [...removeContactText.value, ...theLastTargetWay]
          });
          loadings.value = false
          ElMessage.success(res.message);
          dialogVisible.value = false;
          store.dispatch("customer/getContactList");
          isEdit.value = false;
          removeContactEmail.value = [];
          removeContactPhone.value = [];
          removeContactText.value = [];
          // localStorage.setItem("ContactMessage", JSON.stringify([]))
          sessionStore.set("ContactMessage", [])
          // ruleFormRef.value.resetFields();
          formReset()
        } catch (e) {
          console.log(e, 'e')
          loadings.value = false;
        }
      }
    } else {
      // console.log("error submit!", fields);
    }
  });
}, 500);


// 表单重置
const formReset = () => {
  ruleFormUsers.name = "";
  ruleFormUsers.sex = 1;
  ruleFormUsers.post = "";
  ruleFormUsers.phone = "";
  ruleFormUsers.telPhone = "";
  ruleFormUsers.birthday = null;
  ruleFormUsers.teamId = "";
  ruleFormUsers.remark = "";
  ruleFormUsers.departName = "";
  ruleFormUsers.nickName = ""
  ruleFormUsers.isMain = false;
  ruleFormUsers.contactWayList = [
    {content: "", isDefault: 1}
  ]
  ruleFormUsers.contactPhoneList = [
    {content: "", isDefault: 1}
  ]
  ruleFormUsers.mailContactEmailList = [
    {
      content: "", isDefault: 1,
    },
  ];
  ruleFormUsers.mailContactSouvenirList = [{
    remark: "",
    souvenirDay: "",
    editing: true,
    showButtons: true,
  }];
}

// 添加联系人邮箱
const handleClick = async (tab, event) => {
  // console.log(tab.props.name, event);
  if (tab.props.name === "4") {
    // 操作日志
    await getTargetUserLogs();
  } else if (tab.props.name === "1") {
    await showActiveItem();
  }
};

const table_columns_logs = [
  {key: i18n.global.t('common.bybranch'), value: "userName"},
  {
    key: i18n.global.t('common.operate.time'),
    value: "operateTime",
  },
  {key: i18n.global.t('common.remarkNote'), value: "remark"},
];
const tableDataLogs = ref([]);
const isLoadingLog = ref(false);
// 分页
const currentLog = ref(1);
const sizeLog = ref(10);
const totalsLog = ref(0);

function handleCurrentChange(page) {
  currentLog.value = page;
  getTargetUserLogs();
}

// 获取相关人的日志信息
const getTargetUserLogs = async () => {
  const customerId = sessionStore.get("customerIdDetail");
  isLoadingLog.value = true;
  let res = await getUserLogList({
    customerId: customerId,
    pageNo: currentLog.value,
    pageSize: sizeLog.value,
  });
  if (res.code !== 200) {
    ElMessage.error(res.message);
    return;
  }
  isLoadingLog.value = false;
  const {records, current, size, total} = res.result;
  tableDataLogs.value = records;
  currentLog.value = current;
  sizeLog.value = size;
  totalsLog.value = total;
};

const dialogVisible = ref(false);
// 路由选择
const activeName = ref("1");
// 选择的item
const targetCheckoutItem = ref(i18n.global.t('common_all'));
const islink = ref(false);
const clickHistoryChange = (val) => {
  if (val) {
    activeName.value = "2";
    targetCheckoutItem.value = val.item.email;
    islink.value = true;
    // console.log(val.item.email, "ff");
  }
};
const changeTarget = (val) => {
  islink.value = val.islink;
};
// 添加纪念日
const dates = ref([{value: new Date()}]);
const addEvent = () => {
  ruleFormUsers.mailContactSouvenirList.push({
    remark: "",
    souvenirDay: "",
    editing: true,
    showButtons: true,
  });
  dates.value.push({value: new Date()});
};

// 编辑
const isEdit = ref(false);
const isLoadingDetail = ref(false)
// 记录联系人行id
const contactId = ref("");
const contactMessage = computed(() => store.state.customer.contactMessage);
const contactMessageTemp = ref([])
const onClickEdit = async ({row, column, $index}) => {
  isEdit.value = true;
  const {id} = row;
  // console.log(id, "fff");
  dialogVisible.value = true;
  contactId.value = id;
  const customerId = sessionStore.get("customerIdDetail");
  // 获取联系人详情
  try {
    isLoadingDetail.value = true
    await store.dispatch("customer/getContactDetail", {
      contactId: id,
      customerId: customerId,
    });
    isLoadingDetail.value = false
  } catch (e) {
    isLoadingDetail.value = false
    console.log(e)
  }
  console.log(contactMessage.value, "contactMessage");
  contactMessageTemp.value = contactMessage.value;
  const {
    name,
    post,
    phone,
    telPhone,
    birthday,
    remark,
    sex,
    mailContactEmailList,
    mailContactSouvenirList,
    mailContactPhoneList,
    mailContactWayList,
    isMain,
    nickName,
    departName
  } = contactMessage.value;
  ruleFormUsers.name = name;
  ruleFormUsers.post = post;
  ruleFormUsers.phone = phone;
  ruleFormUsers.telPhone = telPhone;
  ruleFormUsers.birthday = birthday;
  ruleFormUsers.sex = sex;
  ruleFormUsers.remark = remark;
  ruleFormUsers.nickName = nickName;
  ruleFormUsers.departName = departName;
  ruleFormUsers.isMain = (isMain === 1 ? true : false)
  ruleFormUsers.contactPhoneList = mailContactPhoneList.length === 0 ? [{
    content: "",
    isDefault: 1
  }] : mailContactPhoneList.map(item => ({...item, content: item?.phone}))
  ruleFormUsers.mailContactEmailList = mailContactEmailList.length === 0 ? [{
    content: "",
    isDefault: 1,
  }] : mailContactEmailList;
  ruleFormUsers.contactWayList = mailContactWayList.length === 0 ? [{
    content: "",
    isDefault: 1
  }] : mailContactWayList.map(item => ({...item, content: item?.contactWay}));
  ruleFormUsers.mailContactSouvenirList = mailContactSouvenirList.length !== 0 ? mailContactSouvenirList : [{
    remark: "",
    souvenirDay: "",
    editing: true,
    showButtons: true,
  }];
  // Object.assign(ruleFormUsers, contactMessage.value)
};

const cancelClick = () => {
  isEdit.value = false;
  dialogVisible.value = false;
  ruleFormUsers.name = "";
  ruleFormUsers.sex = 1;
  ruleFormUsers.post = "";
  ruleFormUsers.phone = "";
  ruleFormUsers.telPhone = "";
  ruleFormUsers.birthday = null;
  ruleFormUsers.remark = "";
  ruleFormUsers.departName = "";
  ruleFormUsers.nickName = "";
  ruleFormUsers.isMain = false
  ruleFormUsers.contactWayList = [
    {content: "", isDefault: 1}
  ]
  ruleFormUsers.contactPhoneList = [
    {content: "", isDefault: 1}
  ]
  ruleFormUsers.mailContactEmailList = [
    {
      content: "",
      isDefault: 1,
    },
  ];
  ruleFormUsers.mailContactSouvenirList = [{
    remark: "",
    souvenirDay: "",
    editing: true,
    showButtons: true,
  }];
};

const editEvent = (index) => {
  ruleFormUsers.mailContactSouvenirList[index].editing = false;
  nextTick(() => {
    inputRefs[index].focus();
  });
};

const updateEvent = (index) => {
  ruleFormUsers.mailContactSouvenirList[index].editing = true;
  ruleFormUsers.mailContactSouvenirList[index].showButtons = true;
};

const removeEvent = (index) => {
  if (ruleFormUsers.mailContactSouvenirList.length === 1) {
    return
  }
  ruleFormUsers.mailContactSouvenirList.splice(index, 1);
};

const showButtons = (index) => {
  ruleFormUsers.mailContactSouvenirList[index].showButtons = true;
};

const hideButtons = (index) => {
  ruleFormUsers.mailContactSouvenirList[index].showButtons = false;
  ruleFormUsers.mailContactSouvenirList[index].editing = false;

  if (ruleFormUsers.mailContactSouvenirList[index].remark === "") {
    removeEvent(index);
  }
};

const disabledDate = (time) => {
  return time.getTime() > Date.now();
};
const teamId = computed(() => store.state.email.teamID)


// 传递的值
const types = ref();
const selections = computed(() => store.state.cusList.tableData);
onMounted(async () => {

  // 获取客户等级
  // await store.dispatch("cusList/getMailCustomerLevel");
  // await store.commit('customer/setCustomerLevels', selections.value)

  const findTabKey = router.currentRoute.value.query.tabKey;
  const {userId} = router.currentRoute.value.params;
  const {type} = router.currentRoute.value.query;
  if (userId != undefined) {
    sessionStore.set("customerIdDetail", userId);
    store.dispatch("customer/getQueryById", {customerId: userId});
    types.value = type;
    customerId.value = userId;
    // here have bugs
    // await showActiveItem();
  }
  if (findTabKey) {
    activeName.value = findTabKey;
    mainKey.value = mainKey.value + 1
  }
  // await store.dispatch("cusList/getCustomerSelectDataFunction", {
  //   teamId: teamId.value,
  //   type: 1,
  // })
});

const toWritePage = () => {
  // 路由更改
  router.push({path: `/email/write_mail`, query: {customerId: route.params.userId}});
}


const callLog = ref()
const multipleSelection = ref([])
const dialogVisiblePopover = ref(false)
const handleClickDelete = throttle(() => {
  multipleSelection.value = [sessionStore.get("customerIdDetail")]
  if (multipleSelection.value.length === 0) {
    ElMessage.warning(i18n.global.t('common.email.chooseCustomer'));
    return;
  }
  dialogVisiblePopover.value = true;
}, 2000)
const closeDialog = () => {
  dialogVisiblePopover.value = false;
}


const handleCheckForm = debouncePlus(async (type, item) => {
  const payload = {
    teamId: teamId.value,
    email: item.content,
  }
  console.log(payload, item, 'payload')
  if (route.params.userId) {
    payload.customerId = route.params.userId
  }
  const res = await checkEmailAndWebsite(payload)
  if (!isEmpty(res.result) && res.result.email !== "ok" && res.result.email !== '' && item.email !== '') {
    ElMessage.warning(res.result.email)
  }
}, TIME_OUT)


const disabledFlag = ref(true)
// 定义在函数外，避免每次 handleEdit 都重新声明
window.preData = null
const handleEdit = () => {
  if (!disabledFlag.value) {
    // 正在编辑 -> 点击时恢复原始值
    ruleForm.value.customerCode = window.preData
  } else {
    // 从非编辑 -> 进入编辑模式时缓存数据
    window.preData = ruleForm.value?.customerCode
  }
  disabledFlag.value = !disabledFlag.value
}
</script>

<style lang="less" scoped>
@import "./less/detail.less";
@import "../../less/page.less";

h2 {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 700;
  font-size: 21px;
}

.pages {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
}

.top_titles {
  padding-bottom: 20px;
  border-bottom: 1px solid #ebebeb;
}

.small_box {
  width: max-content;
  margin-top: 20px;
}

:deep(.el-drawer) {
  width: 530px;
}

.box_content {
  width: 100%;

  & > div {
    background: #f5f5f5;

    .inners {
      padding: 20px;
      width: 100%;
      background: white;
    }
  }
}

h3 {
  font-size: 16px;
  font-weight: 500;
}

:deep(.el-tabs__active-bar) {
  height: 3px !important;
}

.titles {
  padding: 20px 0px;
  border-bottom: 1px solid #ebebeb;
}

:deep(.el-empty__image img) {
  width: 54% !important;
}

//:deep(.el-form-item:first-child) {
//  padding: 0px 24px 12px 0px;
//}

.views {
  flex-grow: 1;
  height: 100%;
  overflow: hidden;
  background-color: rgb(245, 245, 245);
}

.linkUser {
  display: flex;
  overflow: hidden;
  height: calc(100vh - 17.5vh);
}

:deep(.el-date-editor.el-input) {
  width: 100% !important;
}

:deep(.el-select) {
  width: 100% !important;
}

:deep(.el-form-item__content) {
  justify-content: flex-start !important;
}

#spButton {
  margin-left: -40px !important;
}

.tops {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 10px;
  margin-bottom: 20px;

  .span_block {
    width: 4px;
    height: 16px;
    padding-left: 5px;
    border-left: 4px solid #1890ff;
  }

  .inner_text {
    font-weight: 700;
    color: #000;
  }
}

.outbox {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

:deep(.el-tabs__nav-scroll) {
  width: max-content !important;
}

//:deep(.el-form-item) {
//  margin-bottom: 10px !important;
//}

:deep(.el-input) {
  font-size: 13px !important;
}

:deep(.el-select) {
  font-size: 13px !important;
}

:deep(.el-table .cell) {
  font-size: 13px !important;
  font-weight: normal !important;
}

.gutter_my {
  flex: 1;
  margin: 0px 10px;
}

.gutter_my_sp {
  width: 18.4%;
  margin: 0px 10px;
}


:deep(.el-input) {
  font-size: 13px !important;
}

:deep(.el-select) {
  font-size: 13px !important;
}

.gutter_my_sp_form {
  width: 17.4% !important;
  margin: 0px 10px;
}

#Card {
  padding-top: 0px !important;
}

:deep(.el-form-item__content) {
  margin-left: 0px !important;
  flex-wrap: nowrap !important;
}

:deep(.el-form-item__label) {
  font-size: 13px !important;
  color: rgba(0, 0, 0, 0.85);
  line-height: 26px !important;
  font-weight: normal !important;
}

.demo-ruleForm-ssssss {
  :deep(.el-form-item__label) {
    line-height: 32px !important;
  }
}

.event-input {
  margin-bottom: 7px;
  display: flex;
  align-items: center;
  width: 99.7%;
}

.sp_form_item:first-child {
  margin: 20px 0px 18px 0px !important;
}

:deep(.sp_form_item) {
  height: 24px !important;
  margin-bottom: 18px !important;
}

.contact_my {
  width: 25% !important;
}

.popover-content {
  max-width: 300px;
  max-height: 200px;
  overflow-y: auto;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}

.sp_edit_btn {
  :deep(.el-form-item__label) {
    width: 100%;
    padding-right: 0px;
  }
}

.demo-ruleForm-ssssss {
  .sp_form_item {
    :deep(.el-form-item__label) {
      line-height: 26px !important;
    }
  }
}

:deep(.el-tag) {
  max-width: 100px !important;
}

:deep(.el-form-item__error) {
  padding-top: 0px !important;
}

.sp_form_item {
  :deep(.el-form-item__error) {
    padding-top: 4px !important;
  }
}


.vertical-form-item {
  :deep(.el-form-item__content) {
    display: flex;
    flex-direction: column; /* 垂直排列 */
    align-items: flex-start; /* 左对齐 */
  }
}

.email-input {
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;
}

:deep(.el-checkbox__label) {
  font-size: 14px !important;
  color: #000000 !important;
  font-weight: 500 !important;
}

:deep(.el-tag) {
  max-width: 140px !important
}
</style>
